module.exports = __webpack_public_path__ + "img/i_empty_result.77df185e.svg";